import React from 'react';

import classes from '../constants/classes';
import { prefixCls } from '../utils/style';
import LazyComponent from './LazyComponent';
import { INavConfig } from './type';

interface NavbarOptions {
  config: INavConfig;
}

const Navbar = React.forwardRef<HTMLDivElement, NavbarOptions>(
  ({ config }, ref) => {
    return (
      <div
        className={prefixCls({
          [`${classes.prefix}Navbar`]: true,
        })}
        ref={ref}
      >
        <LazyComponent config={config} />
      </div>
    );
  },
);

export default Navbar;
